import { toast } from "react-toastify";
import { useLanguageContext } from "../../../Context/LanguageContext";
import { AiOutlineDelete, AiOutlineEdit } from "react-icons/ai";
import AddIcon from "@mui/icons-material/Add";
import { useState } from "react";
import AddHersteller from "./AddHersteller";
import equipmentGroupStore from "../../../Stores/EquipmentGroupStore";
import { useEffect } from "react";
import EquipmentGroupContants from "../../../Constants/EquipmentGroupConstants";
import EquipmentGroupActions from "../../../Actions/EquipmentGroupActions";
import { useGlobalSpinnerActionsContext } from "../../../Context/GlobalSpinnerContext";
import commonUtils from "../../../helpers/commonUtils";
import ConfirmationPopUp from "../../MessageBox/ConfirmationPopUp";
import { useSelectedConfigActionContext } from "../../../Context/GlobalContext";
import { customizeFilter } from "../../FilterOptions/CustomizeFilter";
import { Button } from "@mui/material";
import CustomDataGrid from "../../ReusableComponent/DataGrid/CustomizeDataGrid";
import UploadFileOutlinedIcon from "@mui/icons-material/UploadFileOutlined";
import ImportComponent from "../../ReusableComponent/ImportComponent/importComponent";
import ImportAction from "../../../Actions/ImportAction";
import { GridActionsCellItem } from "@mui/x-data-grid-pro";
const HerstellerList = (props) => {
  const [herstellerNameList, setHerstellerNameList] = useState(null);
  const [resHerstellerNameList, setResHerstellerNameList] = useState([]);
  const [herstellerDetails, setHerstellerDetails] = useState("");
  const [confirmationPopUpOpen, setConfirmationPopUpOpen] = useState(false);
  const [confirmationPopUpMsg, setConfirmationPopUpMsg] = useState("");
  const [callbackData, setCallbackData] = useState(null);
  const [eventType, setEventType] = useState(null);
  const { localization } = useLanguageContext();
  const setGlobalSpinner = useGlobalSpinnerActionsContext();
  const updateSelectedConfig = useSelectedConfigActionContext();

  const columns = [
    {
      field: "hersteller",
      headerName: localization.herstellerName,
      hideable: false,
      flex: 1,
    },
    {
      field: "actions",
      type: "actions",
      width: 45,
      hideable: false,
      headerName: localization.actions,
      getActions: (params) => [...getAction(params, localization)],
    },
  ];
  const importIntial = {
    isOpen: false,
    headerTitle: localization.importManuf,
    subHeaderTitle: localization.importManufTitle,
    handleClose: handleCloseImport,
    handleImport: handleImport,
    handleDownloadTemplate: handleDownloadTemplate,
  };
  const [openImport, setOpenImport] = useState(importIntial);
  //------------------------Get Hersteller start ----------------------
  const getHersteller = () => {
    setGlobalSpinner(true);
    EquipmentGroupActions.getHerstelleres("");
  };

  useEffect(() => {
    getHersteller();

    function getHerstelleresSuccess() {
      const res = equipmentGroupStore.getHerstellers();

      if (res.length > 0) {
        const tableData = res.map((item) => ({
          id: item.id,
          hersteller: item.hersteller,
          eigenHerstellung: item.eigenHerstellung,
        }));
        setResHerstellerNameList(tableData);
        setHerstellerNameList(tableData);
      } else {
        setResHerstellerNameList([]);
        setHerstellerNameList([]);
      }
      setGlobalSpinner(false);
      updateSelectedConfig("Manufacturer ");
    }

    function getHerstelleresFailure() {
      setGlobalSpinner(false);
      updateSelectedConfig("Manufacturer ");
    }

    equipmentGroupStore.addChangeListener(
      EquipmentGroupContants.GET_HERSTELLERS_SUCCESS,
      getHerstelleresSuccess,
    );

    equipmentGroupStore.addChangeListener(
      EquipmentGroupContants.GET_HERSTELLERS_FAILURE,
      getHerstelleresFailure,
    );

    return () => {
      equipmentGroupStore.removeChangeListener(
        EquipmentGroupContants.GET_HERSTELLERS_SUCCESS,
        getHerstelleresSuccess,
      );

      equipmentGroupStore.removeChangeListener(
        EquipmentGroupContants.GET_HERSTELLERS_FAILURE,
        getHerstelleresFailure,
      );
    };
  }, []);
  //------------------------Get Hersteller end ----------------------

  //------------------------Add or update Hersteller start ----------------------
  useEffect(() => {
    function addOrUpdateHerstellerSuccess() {
      const res = equipmentGroupStore.getAddOrUpdateHerstellers();
      if (res) {
        commonUtils.hideModalPopUp("addHerstellerModalClose");
        toast.success(
          commonUtils.getIsEdit()
            ? localization.herstellersEditedSuccessfully
            : localization.herstellersAddSuccessfully,
        );
      } else {
        toast.error(res);
      }
      getHersteller();
    }

    function addOrUpdateHerstellerFailure() {
      const res = equipmentGroupStore.getAddOrUpdateHerstellers();
      toast.error(res);
      setGlobalSpinner(false);
    }

    equipmentGroupStore.addChangeListener(
      EquipmentGroupContants.ADD_OR_UPDATE_HERSTELLERS_SUCCESS,
      addOrUpdateHerstellerSuccess,
    );

    equipmentGroupStore.addChangeListener(
      EquipmentGroupContants.ADD_OR_UPDATE_HERSTELLERS_FAILURE,
      addOrUpdateHerstellerFailure,
    );

    return () => {
      equipmentGroupStore.removeChangeListener(
        EquipmentGroupContants.ADD_OR_UPDATE_HERSTELLERS_SUCCESS,
        addOrUpdateHerstellerSuccess,
      );

      equipmentGroupStore.removeChangeListener(
        EquipmentGroupContants.ADD_OR_UPDATE_HERSTELLERS_FAILURE,
        addOrUpdateHerstellerFailure,
      );
    };
  }, []);
  const handleAdd = () => {
    setHerstellerDetails("");
  };
  function RenderAddHersteller() {
    return (
      <>
        <Button
          id="addHerstellerTest"
          className="mr-4 cursorPoint svgIcon"
          variant="outlined"
          startIcon={<AddIcon />}
          data-toggle="modal"
          data-target="#addHersteller"
        >
          {localization.add}
        </Button>
      </>
    );
  }
  //------------------------Add or update Hersteller end ----------------------

  //------------------------Edit Hersteller start ----------------------
  // logic

  const setCurrentHerstellerDetails = (row) => {
    setHerstellerDetails(row);
  };

  function RenderEditButton(props) {
    const currentHersteller = props.currentHersteller;
    return (
      <>
        <Button
          id="editHerstellerTest"
          className="mr-4 cursorPoint svgIcon"
          variant="outlined"
          startIcon={<AiOutlineEdit />}
          data-toggle="modal"
          data-target="#addHersteller"
        >
          {localization.toolTipEdit}
        </Button>
      </>
    );
  }

  //------------------------Edit Hersteller end ----------------------

  //------------------------Delete Hersteller start ----------------------
  useEffect(() => {
    function deleteHerstellerSuccess() {
      const res = equipmentGroupStore.getDeleteHersteller();
      if (res && res.length == 0) {
        toast.success(localization.herstellerDeletedSuccessfully);
      } else if (res && res.length > 0) {
        res.forEach((item) => toast.error(item));
      }

      getHersteller();
    }
    function deleteHerstellerFailure() {
      const res = equipmentGroupStore.getDeleteHersteller();
      if (res && res.length == 0) {
        toast.error(res);
      } else if (res && res.length > 0) {
        res.forEach((item) => toast.error(item));
      }

      setGlobalSpinner(false);
    }

    equipmentGroupStore.addChangeListener(
      EquipmentGroupContants.DELETE_HERSTELLRS_SUCCESS,
      deleteHerstellerSuccess,
    );

    equipmentGroupStore.addChangeListener(
      EquipmentGroupContants.DELETE_HERSTELLRS_FAILURE,
      deleteHerstellerFailure,
    );

    return () => {
      equipmentGroupStore.removeChangeListener(
        EquipmentGroupContants.DELETE_HERSTELLRS_SUCCESS,
        deleteHerstellerSuccess,
      );

      equipmentGroupStore.removeChangeListener(
        EquipmentGroupContants.DELETE_HERSTELLRS_FAILURE,
        deleteHerstellerFailure,
      );
    };
  }, []);

  function deleteHerstellerCallback(herstellerIDs) {
    setConfirmationPopUpOpen(true);
    setConfirmationPopUpMsg(localization.areYouSureYouWantToDeleteManufacture);
    setCallbackData({
      herstellerID: herstellerIDs,
    });
    setEventType("DELETE_HERSTELLER");
  }
  function handleImportClick() {
    setOpenImport((prev) => ({
      ...prev,
      isOpen: true,
    }));
  }
  function RenderImportButton() {
    return (
      <Button
        id="import"
        className="svgIcon cursorPoint"
        variant="outlined"
        startIcon={<UploadFileOutlinedIcon />}
        onClick={handleImportClick}
      >
        {localization.import}
      </Button>
    );
  }
  const confirmationOkCancelCallback = (isConfirmed, eventType, data) => {
    if (isConfirmed) {
      switch (eventType) {
        case "DELETE_HERSTELLER":
          setGlobalSpinner(true);
          const res = EquipmentGroupActions.deleteHersteller(data.herstellerID);
          closePopUpCallback();
          break;
        default:
          break;
      }
    } else {
      closePopUpCallback();
    }
  };

  const closePopUpCallback = () => {
    setConfirmationPopUpOpen(false);
    setConfirmationPopUpMsg("");
    setCallbackData(null);
    setEventType(null);
  };

  const closeAddEditHerstellerPopUpCallback = () => {
    setHerstellerDetails("");
  };

  const handleDelete = (row) => {
    const _idList = [];
    if (Array.isArray(row)) {
      row.forEach((b) => _idList.push(b.id));
    } else {
      _idList.push(row.id);
    }
    deleteHerstellerCallback(_idList);
    commonUtils.hideModalPopUp("addHerstellerModalClose");
  };

  function RenderDeleteButton() {
    return (
      <>
        <Button
          id="deleteHerstellerTest"
          className="mr-4 cursorPoint svgIcon"
          variant="outlined"
          startIcon={<AiOutlineDelete />}
        >
          {localization.delete}
        </Button>
      </>
    );
  }
  //------------------------Delete Hersteller end ----------------------
  const operations = {
    RowOperationList: [
      {
        label: "Edit",
        component: <RenderEditButton />,
        onClick: setCurrentHerstellerDetails,
      },
      {
        label: "Delete",
        component: <RenderDeleteButton />,
        onClick: handleDelete,
      },
    ],
    GridToolBarAction: [
      { label: "Add", component: <RenderAddHersteller />, onClick: handleAdd },
      {
        label: "Import",
        component: <RenderImportButton />,
        onClick: handleImportClick,
      },
    ],
    SelectedToolBar: [
      {
        label: "Delete",
        component: <RenderDeleteButton />,
        onClick: handleDelete,
      },
    ],
  };

  function handleImport(seletedFile) {
    setGlobalSpinner(true);
    const obj = {
      ImportType: "Manufacturer",
      ImportFile: seletedFile,
    };
    ImportAction.uploadData(obj);
  }

  function handleCloseImport(_message) {
    if (_message === "success") {
      getHersteller();
    }
    setOpenImport((prev) => ({
      ...prev,
      isOpen: false,
    }));
  }

  function handleDownloadTemplate() {
    ImportAction.getTemplate({
      ImportType: "Manufacturer",
      UpdateTempalte: false,
    });
    setGlobalSpinner(true);
  }
  function getAction(params) {
    const _acionList = [];
    _acionList.push(
      <GridActionsCellItem
        label={localization.toolTipEdit}
        showInMenu
        onClick={() => setCurrentHerstellerDetails(params.row)}
        data-toggle="modal"
        data-target="#addHersteller"
      />,
    );
    _acionList.push(
      <GridActionsCellItem
        label={localization.delete}
        showInMenu
        onClick={() => handleDelete(params.row)}
      />,
    );

    return _acionList;
  }
  return (
    <>
      <div
        style={{ height: "100%", width: "100%", overflow: "auto" }}
        id="content"
      >
        {herstellerNameList && (
          <CustomDataGrid
            Title={localization.orgSetting + " / " + localization.manufacturer}
            columns={columns}
            rows={herstellerNameList}
            operations={operations}
            onAdd={handleAdd}
            showExport={true}
            showColumns={true}
            showFilters={true}
            showDensity={true}
            visibleColumns={["hersteller"]}
            showCheckBox={true}
            gridTableHeight={"dataGridLarge"}
          />
        )}
      </div>

      <AddHersteller
        herstellerDetails={herstellerDetails}
        closeAddEditHerstellerPopUpCallback={
          closeAddEditHerstellerPopUpCallback
        }
      />
      <ConfirmationPopUp
        isOpen={confirmationPopUpOpen}
        okCancelCallback={confirmationOkCancelCallback}
        close={closePopUpCallback}
        title=""
        msg={confirmationPopUpMsg}
        eventType={eventType}
        callbackData={callbackData}
      />
      {openImport.isOpen && <ImportComponent data={openImport} />}
    </>
  );
};

export default HerstellerList;
